export class ConsumerProductSoldOutError extends Event {
    static NAME = "consumer:product-sold-out-error";

    constructor(readonly details: { productId: string; startDate: string; endDate: string }) {
        super(ConsumerProductSoldOutError.NAME, {
            bubbles: true,
            cancelable: false,
        });
    }
}
